import { isAccessTokenExpires, isAccessTokenValid } from '../helpers';
import { authStorage } from '../storages';
import { refreshAuthToken } from '../api';
import type { ISamoletConfiguration } from '../types';

export async function checkCurrentAuth(config: ISamoletConfiguration) {
  const jwtAuthParams = authStorage.getJwtAuthParams();

  if (!jwtAuthParams || !jwtAuthParams.access || !jwtAuthParams.refresh) {
    return false;
  }

  if (
    isAccessTokenExpires(jwtAuthParams.access) ||
    !isAccessTokenValid(jwtAuthParams.access)
  ) {
    try {
      const { access_token, refresh_token } = await refreshAuthToken(
        config,
        jwtAuthParams.refresh,
      );

      await authStorage.setJwtAuthParams({
        access: access_token,
        refresh: refresh_token,
      });
    } catch (err) {
      return false;
    }
  }

  return true;
}
